import dataHandler_alert from "../../actions/dataHandler_alert";
import BH from "./../../actions/BedHandler";
import comm_imgs from "../../comm_imgs"
import { LogTime } from "../../actions/forFrontEnd_Log";
import React from "react";

export class DF {        // DF for dashboard functions
    // 判斷 alert 顏色
    static alert_emergency(_priority, _type) {
        if (_priority === undefined || _priority === null) { return }
        if (_type === undefined || _type === null) { return }
        if (dataHandler_alert(_priority, _type).level === "emergency") { return "bgc-level-emergency" }
        else if (dataHandler_alert(_priority, _type).level === "warning") { return "bgc-level-warning" }
        else { return }
    }
    // alert 轉中文 
    static alert(_priority, _type) {
        if (_priority === undefined || _priority === null) { return 'GLOBAL.ALERT_STATE_1' }
        if (_type === undefined || _type === null) { return 'GLOBAL.ALERT_STATE_1' }
        return dataHandler_alert(_priority, _type).msg
    }
    // alert 轉圖片 
    static alert_img(_priority, _type) {
        if (_priority === undefined || _priority === null) { return comm_imgs['LEVEL_0']['1_NO_IN_BED'] }
        if (_type === undefined || _type === null) { return comm_imgs['LEVEL_0']['1_NO_IN_BED'] }
        return dataHandler_alert(_priority, _type).img
    }
    // 呼吸次數顏色
    static breath_emergency(_events, _mos_rr, _breath_high, _breath_low) {
        if (_events === null || _events === undefined) { return }
        if (_events.bed_state !== 15 && _events.bed_state !== 4) { return }
        if (_mos_rr === null || _mos_rr === undefined) { return }
        if (_mos_rr.value >= _breath_high || _mos_rr.value <= _breath_low) { return "c-level-emer" }   // first identifer
    }
    // 呼吸次數
    static breath_count(_events, _mos_rr, _mac) {
        if (_events === null || _events === undefined) { return '-' }
        if (_mos_rr === null || _mos_rr === undefined) { return '-' }
        if (parseInt(_events.alert_type_id) !== 15 &&
            parseInt(_events.alert_type_id) !== 4 &&
            parseInt(_events.alert_type_id) !== 7 &&
            parseInt(_events.alert_type_id) !== 8 &&
            parseInt(_events.alert_type_id) !== 217 &&
            parseInt(_events.alert_type_id) !== 501 &&
            parseInt(_events.alert_type_id) !== 502 &&
            parseInt(_events.alert_type_id) !== 503 &&
            parseInt(_events.alert_type_id) !== 504 &&
            parseInt(_events.alert_type_id) !== 505 &&
            parseInt(_events.alert_type_id) !== 511 &&
            parseInt(_events.alert_type_id) !== 512) { return '-' }
        if (_mos_rr.mac !== _mac) { return "-" }
        return _mos_rr.value  // first identifer 
    }
    // 呼吸 + 心跳 ==> 同component 串接 (不透過dashboard 迴圈，直接dashrow or card處理)
    static vital_count(_events, _mos, _mac, temp, setTemp) {
        if (_events === null || _events === undefined) { return '-' }
        if (_mos === null || _mos === undefined || _mos.mac_left !== _mac) {
            if (temp === null || temp === undefined) { return '-' }
            else { return temp.value }
        }
        if (temp !== null) {
            if (_mos.value !== temp.value) { setTemp(_mos) }
        } else { setTemp(_mos) }
        if (parseInt(_events.alert_type_id) !== 15 &&
            parseInt(_events.alert_type_id) !== 4 &&
            parseInt(_events.alert_type_id) !== 7 &&
            parseInt(_events.alert_type_id) !== 8 &&
            parseInt(_events.alert_type_id) !== 217 &&
            parseInt(_events.alert_type_id) !== 501 &&
            parseInt(_events.alert_type_id) !== 502 &&
            parseInt(_events.alert_type_id) !== 503 &&
            parseInt(_events.alert_type_id) !== 504 &&
            parseInt(_events.alert_type_id) !== 505 &&
            parseInt(_events.alert_type_id) !== 511 &&
            parseInt(_events.alert_type_id) !== 512



        ) { return '-' }
        return _mos.value  // first identifer 
    }
    // 呼吸 + 心跳 ==> 同component 串接 (不透過dashboard 迴圈，直接dashrow or card處理)
    static scientechTemparay(_mos, temp, setTemp) {
        let _time = new LogTime().getFullTime_withoutMillsec()
        if (_mos === null || _mos === undefined) {
            if (temp === null || temp === undefined) { return '-' }
            else { return temp.value }
        }
        if (temp !== null) {
            if (_mos.value !== temp.value) { setTemp({ ..._mos, time: _time }) }
        } else { setTemp({ ..._mos, time: _time }) }
        return _mos.value  // first identifer 
    }
    // all lock and auto 
    static moteckAL(_moteck, _identifer, _bed_id, _local) {
        if (_moteck === null || _moteck === undefined) {
            if (_local === null || _local === undefined) { return "off" }
            if (_local.bed_id !== _bed_id) { return "off" }
            if (_local[_identifer] === 1 || _local[_identifer] === "1") { return "on" }
            return "off"
        }
        if (_moteck.bed_id !== _bed_id) {
            if (_local === null || _local === undefined) { return "off" }
            if (_local.bed_id !== _bed_id) { return "off" }
            if (_local[_identifer] === 1 || _local[_identifer] === "1") { return "on" }
            return "off"
        }
        if (_moteck[_identifer]) { return "on" }
        else { return "off" }
    }

    // MOTECK : height, turn count, turn angle, back angle, foot angle 
    static moteck_integrate(_moteck, _bed_id, _api, _identifer) {
        if (_moteck === null || _moteck === undefined) {
            if (_api === null || _api === undefined) { return 0 }
            if (_api[_identifer] < 0) { return '-' }
            return _api[_identifer]
        }
        if (_moteck.bed_id === _bed_id) {
            if (_moteck[_identifer] < 0) { return '-' }
            return _moteck[_identifer]
        }
        else {
            if (_api === null || _api === undefined) { return 0 }
            return _api[_identifer]
        }
    }
    // turn position style
    static turn_position_css(_moteck, _bed_id, _api, _identifer) {
        if (_moteck === null || _moteck === undefined) {
            if (_api === null || _api === undefined) { return "d-none" }
            if (_api[_identifer] !== 0) { return "" }
            return "d-none"
        }
        if (_moteck.bed_id === _bed_id) {
            if (_moteck[_identifer] !== 0) { return "" }
            return "d-none"
        }
        if (_api === null || _api === undefined) { return "d-none" }
        if (_api[_identifer] !== 0) { return "" }
        return "d-none"
    }
    // turn position
    static turn_position(_moteck, _bed_id, _api, _identifer) {
        if (_moteck === null || _moteck === undefined) {
            if (_api === null || _api === undefined) { return null }
            if (_api[_identifer] < 0) { return '' }
            if (_api[_identifer]) { return 'GLOBAL.RIGHT' }
            return 'GLOBAL.LEFT'
        }
        if (_moteck.bed_id === _bed_id) {
            if (_moteck[_identifer] < 0) { return '' }
            if (_moteck[_identifer]) { return 'GLOBAL.RIGHT' }
            return 'GLOBAL.LEFT'
        }
        if (_api === null || _api === undefined) {
            return 'GLOBAL.LEFT'
        }
        if (_api[_identifer]) { return 'GLOBAL.RIGHT' }
        return ""
    }

    // diaper  
    // angle_abnormal: 1
    // bed_id: "1"
    // clean_count: 58
    // clean_weight_all_day: 3043
    // created_at: "2022-06-21 08:52:48"
    // date: "2022-06-21"
    // discharge_weight: 67
    // is_wash: 0
    // need_to_wash: 1
    // poop_bowl_abnormal: 1
    // sewage_volume: 0
    // water_not_enough: 1
    static diaper(mos, apiData) {
        if (mos === null || mos === undefined) {
            if (apiData === null || apiData === undefined) {
                return {
                    clean_count: 0,
                    clean_weight_all_day: 0,
                    abnormal_first: '',
                    abnormal_second: ''
                }
            }
            if (apiData.poop_bowl_abnormal === 1 || apiData.sewage_volume === 1 || apiData.water_not_enough === 1 || apiData.angle_abnormal === 1) {
                return {
                    clean_count: '無法清洗',
                    clean_weight_all_day: '請查看異常',
                    abnormal_first: 'diaper_Alert first',
                    abnormal_second: 'diaper_Alert second'
                }
            }
            return apiData
        }
        if (mos.poop_bowl_abnormal === 1 || mos.sewage_volume === 1 || mos.water_not_enough === 1 || mos.angle_abnormal === 1) {
            return {
                clean_count: '無法清洗',
                clean_weight_all_day: '請查看異常',
                abnormal_first: 'diaper_Alert first',
                abnormal_second: 'diaper_Alert second'
            }
        }
        return {
            clean_count: apiData.clean_count,
            clean_weight_all_day: apiData.clean_weight_all_day,
            abnormal_first: '',
            abnormal_second: ''
        }
    }

    // bed status
    static bed_status(_mos_moteck, _bed_id, _api) {
        /**
         * "resident_id": int, resident id 
         * "height": int, 床墊目前高度 
         * "back_angel": int, 床墊目前背部角度 
         * "foot_angel": int, 床墊目前腳的角度 
         * "turn_angel": int, 床墊目前翻身角度 
         * "turn_position": int, 床墊目前翻身方向, 0為左翻, 1為右翻 
         * "turn_over": int, 床墊目前是否完成一次翻身, 0為無,1為有 
         * "lie_flat": int, 床墊目前是否躺平,, 0為無,1為有 
         * "is_lowest": int, 床墊目前是否最低, 0為無,1為有 
         * "turn_count": int, 床墊今天目前已翻身次數, 
         * "auto": int, 床墊目前是否auto,, 0為無,1為有 
         * "all_lock": int, 床墊目前是否all lock, 0為無,1為有 
         */

        let data = {
            foot_angle: 0,
            back_angle: 0,
            turn_position: 0,
            turn_angle: 0,
            height: 395,
        };

        if (_mos_moteck !== undefined && _mos_moteck !== null) {
            if (_mos_moteck.bed_id === _bed_id) {
                data['foot_angle'] = _mos_moteck.foot_angel;
                data['back_angle'] = _mos_moteck.back_angel;
                data['turn_position'] = _mos_moteck.turn_position;
                data['turn_angle'] = _mos_moteck.turn_angel;
                data['height'] = _mos_moteck.height;
            }
        } else if (_api !== undefined && _api !== null) {
            if (_api.bed_id === _bed_id) {
                data['foot_angle'] = _api.foot_angel;
                data['back_angle'] = _api.back_angel;
                data['turn_position'] = _api.turn_position;
                data['turn_angle'] = _api.turn_angel;
                data['height'] = _api.height;
            }
        }

        const status = BH.getStatus({
            foot_angle: data['foot_angle'],
            back_angle: data['back_angle'],
            turn_position: data['turn_position'],
            turn_angle: data['turn_angle']
        })

        return {
            img: status.img,
            msg: status.msg,
            data: data,
        }
    }

    static abbreviate(str = '', length) {
        if (str === null || str === undefined) { return '' }
        if (length === "all") {
            return str
        }
        if (str.length > length) {
            return <div className='abbri' title={str}>{str.substring(0, length)}</div>
        }
        else { return <div>{str}</div> }
    }
}

